module.exports = __webpack_public_path__ + "static/media/cancel.a04aae8e.png";